module.exports = __webpack_public_path__ + "static/media/PaperFootballTouchArea.a20dcf15.png";